import { QueryClient, type VueQueryPluginOptions } from '@tanstack/vue-query';
import { isApiError } from '@/shared/api/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (isApiError(error)) {
          if (error.isUnauthorized || error.isForbidden || error.isNotFound) return false;
          if (error.isValidation) return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export const vueQueryOptions: VueQueryPluginOptions = { queryClient };
